/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RotateCWIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rotate C W',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="9.253" cy="29.988" r="1.1" />
    <circle cx="5.653" cy="26.121" r="1.1" />
    <circle cx="14.008" cy="32.269" r="1.1" />
    <circle cx="19.204" cy="32.756" r="1.1" />
    <circle cx="24.288" cy="31.419" r="1.1" />
    <circle cx="28.633" cy="28.392" r="1.1" />
    <circle cx="31.546" cy="24.202" r="1.1" />
    <path
      d="M18 1.8a15.948 15.948 0 0 1 11.273 4.66L32.7 4.1a.5.5 0 0 1 .781.463l-1.048 10.221-9.9-2.679a.5.5 0 0 1-.153-.894l3.346-2.3a13.533 13.533 0 0 0-8.7-3.1c-7.18 0-13.019 5.457-13.019 12.084v.028a14.832 14.832 0 0 0 .344 3.006 1.072 1.072 0 0 1-.7 1.254 1.08 1.08 0 0 1-1.262-.856A16 16 0 0 1 18 1.8Z"
    />
  </svg>`;
};
